import { Component } from '@angular/core';

@Component({
  selector: 'app-scolarships',
  templateUrl: './scolarships.component.html',
  styleUrl: './scolarships.component.css',
})
export class ScolarshipsComponent {}
